/**
 * Component Registry for Black Canyon Luxury Apartments
 * 
 * Inherits from @vibesites-apartment-management-consultants/theme-theme-homestead-milburn and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-apartment-management-consultants/theme-theme-homestead-milburn/registry';
import { PropertyOverview } from './components/PropertyOverview';
import { Header } from './components/Header';
import { ParallaxBanner } from './components/ParallaxBanner';
import { HeroCallouts } from './components/HeroCallouts';
import { ThankYouContent } from './components/ThankYouContent';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  PropertyOverview,
  Header,
  ParallaxBanner,
  HeroCallouts,
  ThankYouContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
